import axios from 'axios'
import Vue from 'vue'
import router from '../router/index.js'
import {Message} from 'element-ui'
import qs from 'qs'


//用户登录信息在localStroage中存放的位置
export const SESSION_LOGIN_INFO = 'loginInfo';

//API请求正常，数据正常
export const API_CODE = {
   //API请求正常
   OK: 200,
   //API请求正常，数据异常
   ERR_DATA: 403,
   //API请求正常，空数据
   Err_NO_DATA: 301,
   //API请求正常，登录异常
   TIME_OUT: 401,
   //token超时
   ERR_LOGOUT: 1100003
}

//API请求异常统一报错提示
export const API_FAILED = '网络连接异常，请稍后再试'
export const API_LOGOUT = '您的账号已在其他设备登录，请重新登录'


export let API_DOMAIN = null;

//使用从dist/config/dynamicConfig.js中读取的配置
if (localStorage.dynamicConfig) {
   let newConfig = JSON.parse(localStorage.dynamicConfig);
   if (newConfig.server_url) {
      API_DOMAIN = newConfig.server_url;
   }
}

/*
 *api请求封装（带验证信息）
 *config.method:[必填]请求method
 *config.url :[必填]请求url
 *config.data ：请求数据
 *config.down : 文件下载或Excel导出
 *config.formData ：是否以formData格式提交（用于上传文件）
 *config.success(res)：请求成功回调
 *config.fail(err)：请求失败回调
 *config.done()：请求结束回调
 */

export function apiRequest(config) {
   const loginInfo = JSON.parse(window.localStorage.getItem(SESSION_LOGIN_INFO));
   if (config.data === undefined) {
      config.data = {}
   }
   config.method = config.method || 'post'

   //封装header信息
   let headers = {
      'token': localStorage.getItem('token') ? localStorage.getItem('token') : null
   }

   //组装axios
   let axiosConfig = {
      method: config.method,
      url: API_DOMAIN + config.url,
      headers
   }

   //post请求采用formDate方式
   if(config.method === 'post')
      config.formData = true

   let data = null
   //判断是否使用formData方式提交
   if (config.formData) {
      headers['Content-Type'] = 'multipart/form-data'
      data = new FormData()
      Object.keys(config.data).forEach(function (key) {
         data.append(key, config.data[key])
      })
   } else {
      data = config.data
   }

   //判断是get还是post，并且加入发送的数据
   if (config.method === 'get') {
      //qs.stringify(data, {arrayFormat: 'repeat'});
      axiosConfig.params =  data
   } else {
      axiosConfig.data = data
   }

   //处理文件下载和Excel导出
   if (config.down) {
      var para = "?d=1"
      //数据赋值
      Object.keys(axiosConfig.params).forEach((key) => {
         para += "&" + key + '=' + axiosConfig.params[key];
      })
      window.open(axiosConfig.url + para);
      return;
   }

   //发起请求
   axios(axiosConfig).then((res) => {
      let result = res.data
      config.done && config.done()
      console.log('返回数据', result);
      if (result.code === API_CODE.ERR_LOGOUT) {
         //Token过期，回到登录页面
         localStorage.removeItem('token')
         router.replace('/')
      } else if (result.code === API_CODE.OK) {
         //请求成功
         config.success && config.success(result)
      } else {
         //请求失败，出现异常
         Message.error(result.msg)
      }
   }).catch((err) => {
      //如果接口不对或出现错误，则弹出antd的modal对话框
      console.error(API_FAILED, err)
      //执行fail的回调
      config.fail && config.fail(API_FAILED)
      //执行done的回调
      config.done && config.done()
   })
}
